import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  HStack,
  Image,
} from '@chakra-ui/react';

import { useGetCompanyByIdQuery } from '../../services';
import { ReactComponent as ChevronRightIcon } from '../../assets/icons/chevron-right.svg';

export const CompaniesLayout = () => {
  const location = useLocation();
  const params = useParams();
  const { companyId } = params;
  const status = params.status || 'all';

  const { data } = useGetCompanyByIdQuery(Number(companyId), {
    skip: !companyId,
  });

  return (
    <Box mx="8" h="full" display="flex" flexDirection="column">
      <Breadcrumb separator={<ChevronRightIcon />}>
        <BreadcrumbItem>
          <HStack fontSize="xs" color="custom_blue.1">
            <Image
              src="/sidebar/companies.svg"
              alt="companies icon"
              boxSize="4"
            />
            <Box>Companies</Box>
          </HStack>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage={location.pathname.endsWith(status)}>
          <BreadcrumbLink
            as={Link}
            to={`/companies/${status}`}
            fontSize="xs"
            color="custom_blue.1"
            textTransform="capitalize"
          >
            {status ? status : 'All'} Companies
          </BreadcrumbLink>
        </BreadcrumbItem>

        {(location.pathname.includes('new-company') || companyId) && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('new-company')}
          >
            {companyId ? (
              <BreadcrumbLink
                as={Link}
                to={`/companies/${status}/${companyId}`}
                fontSize="xs"
                color="custom_blue.1"
              >
                {data?.data.name}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink
                as={Link}
                to={`/companies/${status}/new-company`}
                fontSize="xs"
                color="custom_blue.1"
              >
                Add New Company
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        )}

        {location.pathname.includes('basic-info') && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('basic-info')}
          >
            <BreadcrumbLink
              as={Link}
              to={`/companies/${status}/${
                companyId ? companyId : 'new-company'
              }/basic-info`}
              fontSize="xs"
              color="custom_blue.1"
            >
              Basic Info
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}

        {location.pathname.includes('contact-info') && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('contact-info')}
          >
            <BreadcrumbLink
              as={Link}
              to={`/companies/${status}/${companyId}/contact-info`}
              fontSize="xs"
              color="custom_blue.1"
            >
              Contact Info
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}
        {location.pathname.includes('subscription-plans') && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('subscription-plans')}
          >
            <BreadcrumbLink
              as={Link}
              to={`/companies/${status}/${companyId}/subscription-plans`}
              fontSize="xs"
              color="custom_blue.1"
            >
              Subscription Plan
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}

        {location.pathname.includes('team') && (
          <BreadcrumbItem isCurrentPage={location.pathname.endsWith('team')}>
            <BreadcrumbLink
              as={Link}
              to={`/companies/${status}/${companyId}/team`}
              fontSize="xs"
              color="custom_blue.1"
            >
              Team
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}
      </Breadcrumb>

      <Outlet />
    </Box>
  );
};
